import NavHeader from "../shared/Nav-Header";
import { useState, useEffect, useMemo } from "react";
import styles from './groups.module.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Notification from '../shared/Notification';
import SocialMessageBox from '../shared/SocialMessageBox';
import defaultProfile2 from '../images/default-profile2.jpg';
import { CopyLinkIcon, LeaveGroupIcon, ReportIcon } from '../shared/icons/Icons';
import defaultGroup2 from '../images/groups/group-2.png';
import { useAuth } from '../context/AuthContext';
import { io } from 'socket.io-client';


const getSocketURL = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://server-production-a1b2.up.railway.app/';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

const socket = io(getSocketURL(), { 
  transports: ['websocket', 'polling'],
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000
});


const Groups = () => {
    const { userId } = useAuth();
    const [showGroupCreation, setShowGroupCreation] = useState(false);
    const [notification, setNotification] = useState('');
    const [groupName, setGroupName] = useState('');
    const [selectedNetworks, setSelectedNetworks] = useState([]);
    const [myGroups, setMyGroups] = useState([]);
    // const [myActiveGroups, setMyActiveGroups] = useState([]);
    // const [leftGroups, setLeftGroups] = useState([]);
    const [activeGroupChat, setActiveGroupChat] = useState(null);
    const [projectNetworkList, setProjectNetworkList] = useState([]);
    // const [name, setName] = useState('');
    // const [profilePicture, setProfilePicture] = useState('');
    // const [reload, setReload] = useState(false);
    const [newGroupCreated, setNewGroupCreated] = useState(false);
    const [showOptions, setShowOptions] = useState(null);
    // const [leaveGroupPopup, setLeaveGroupPopup] = useState(false);
    const [reportGroupPopup, setReportGroupPopup] = useState(false);
    const [reportGroupId, setReportGroupId] = useState(null);
    const navigate = useNavigate();
    const [reportMessage, setReportMessage] = useState('');
    const token = useMemo(() => localStorage.getItem('token'), []);
    const socialType = 'group';


    const fetchData = async () => {
        try {
            if (!token) {
                localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                navigate('/login');
                return;
            }
            const response = await axios.get('/api/pn/my-networks', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            // console.log("my-networks", response.data);
            const projectNetworkList = response.data;
            setProjectNetworkList(projectNetworkList);
            // console.log('Profile Picture:', profilePicture);
            // console.log('Project Network List:', projectNetworkList);
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Error fetching project networks data';
            // console.error(errorMessage);
            setNotification('Error fetching project networks data. Please try again.');
        }
    };

    useEffect(() => {
        if (!token) {
            localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
            navigate('/login');
            return;
        }
        
        const message = localStorage.getItem('notification');
        if (message) {
            setNotification(message);
            localStorage.removeItem('notification');
            }
    }, [navigate]);


    useEffect(() => {
        const fetchGroups = async ()=> {
            try {
                const response = await axios.get('/api/group/my-groups', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setMyGroups(response.data.groups);
                // console.log('response.data.', response.data);
                // console.log('response.data.applicant:', response.data.applicant);
                // console.log('response.data.groups:', response.data.groups);
                
                // console.log('response.data.groups:', response.data.groups.map(g => g.membership));
                // setMyActiveGroups(response.data.groups.filter(group =>group.membership === 'member'));
            } catch (error) {
                // console.error('Error fetching user groups:', error);
            }
        }
        fetchGroups();
    }, [navigate]);

    useEffect(() => {
            const handleGroupSort = ({ socialId, createdAt }) => {
                setMyGroups(prev => {
                    // Check if group exists
                    const groupExists = prev.some(g => g._id === socialId);
                    if (!groupExists) return prev;
    
                    // Update and sort
                    return [...prev]
                        .map(g =>
                            g._id === socialId
                                ? { ...g, lastMessageCreatedAt: createdAt }
                                : g
                        )
                        .sort((a, b) => {
                            const dateA = new Date(a.lastMessageCreatedAt || 0);
                            const dateB = new Date(b.lastMessageCreatedAt || 0);
                            return dateB - dateA; // Descending order (latest first)
                        });
                });
            };
    
            socket.on('groupLastMessageUpdate', handleGroupSort);
            return () => socket.off('groupLastMessageUpdate', handleGroupSort);
        }, []);

    // useEffect(() => {
    //     setLeftGroups(myGroups.filter(group =>group.membership === 'left'));
    //     console.log('Active Groups:', myActiveGroups);
    //     console.log('Left Groups:', leftGroups);
    // }, [myGroups]);

    const handleShowGroupCreation = () => {
        fetchData();
        if(showGroupCreation) {
            setShowGroupCreation(false);
        } else {
            setShowGroupCreation(true);
        }
    };

    const handleCreateGroup = async () => {
        try {
            const response = await axios.post('/api/group/create-group', {
                groupName,
                userIds: selectedNetworks
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setGroupName('');
                setSelectedNetworks([]);
                setShowGroupCreation(false);
                setTimeout(() => setNewGroupCreated(true), 0);
                setNotification(response.data.message || 'Group created successfully!');
            }
        } catch (error) {
            // console.error('Error creating group:', error);
            const errorMessage = error.response?.data?.message || 'Error creating group. Please try again.';
            setNotification(errorMessage);
        }
    };

     const handleSelectNetwork = async (event, networkId) => {
        event.stopPropagation();
        setSelectedNetworks((prevSelected) => {
            if (prevSelected.includes(networkId)) {
                return prevSelected.filter(id => id !== networkId);
            } else {
                return [...prevSelected, networkId];
            }
        });
    };
    const handleLeaveGroup = async (e, groupId) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            const response = await axios.post('/api/group/leave-group', {
                groupId,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification(response.data.message || 'Group Left successfully!');
                setNotification( 'Group Left successfully!');
                setTimeout(() => {
                    navigate(-1);
                }, 5000);
            }
        } catch (error) {
            // console.error('Error leaving group:', error);
            const errorMessage = error.response?.data?.message || 'Error leaving group. Please try again.';
            setNotification(errorMessage);
        }
    };

    const handleDeleteGroup = async (groupId) => {
        try {
            const response = await axios.post('/api/group/delete-group', {
                groupId,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification(response.data.message || 'Group Deleted successfully!');
                setTimeout(() => {
                    navigate(-1);
                }, 5000);
            }
        } catch (error) {
            // console.error('Error leaving group:', error);
            const errorMessage = error.response?.data?.message || 'Error deleting group. Please try again.';
            setNotification(errorMessage);
        }
    };

    const handleCopyInviteLink = async (e, groupId) => {
        e.preventDefault();
        e.stopPropagation();
        // console.log("Generating invite link for groupId:", groupId);
        try {
            const response = await axios.post('/api/group/invite-link', 
                { groupId },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.success) {
                // console.log('response.data:', response.data);
                // console.log('Invite link generated:', response.data.inviteLink);
                const inviteLink = response.data.inviteLink;
                
                await navigator.clipboard.writeText(inviteLink);
                
                const expiresAt = new Date(response.data.expiresAt);
                const now = new Date();
                const daysLeft = Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24));
                
                setNotification(`Invite link copied to clipboard! Invite link will be valid for ${daysLeft} days.`);
            }
        } catch (err) {
            // console.error('Error generating invite link:', err.message);
            setNotification(err.response?.data?.message || 'Failed to generate invite link. Please try again.');
        }
    };

    const handleReportGroup = async (e, groupId) => {
        e.preventDefault();
        e.stopPropagation();            
        try{
            await axios.post('/api/group/report-group', {
                groupId: groupId,
                reportMessage: reportMessage
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setReportGroupPopup(false);
            setNotification('Group reported. Our team will review it shortly.');
        }
        catch (error) {
            // console.error('Error reporting group:', error.message);
            const errorMessage = error.response?.data?.message || 'Error reporting group. Please try again.';
            setNotification(errorMessage);
        }
        
    }
    const handleReportGroupPopup = (groupId) => {
        setReportGroupPopup(true);
        setReportGroupId(groupId);
    };
    const cancelReportGroup = () => {
        setReportGroupPopup(false);
    };

    const handleGroupClick = async (event, group) => {
        event.stopPropagation();
        event.preventDefault();
        navigate(`/group/${group._id}`
            ,{ state: { userId: userId } });
    };
    const handleGroupChatClick = async (event, group) => {
        event.stopPropagation();
        setActiveGroupChat(group);
    };

     const handleCloseChat = () => {
        setActiveGroupChat(null);
    };
    const handleCloseNotification = () => {
        setNotification('');
    };
    const handleBack = () => {
        navigate(-1);
    }
    const handleGroupOptions = (event, index) => {
        event.stopPropagation();
        if (showOptions === index) {
            setShowOptions(null);
        } else {
            setShowOptions(index);
        }
    };

    const handleClickOutside = (event) => {
        if (!event.target.closest(`.${styles.threeDotsButton}`) && !event.target.closest(`.${styles.messageOptionsMenu}`)) {
            setShowOptions(null);
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleProfileClick = async (event, networkId) => {
        event.stopPropagation();
        const profileStatus = 'friends';
        // console.log("profileStatus:hp", profileStatus);
        navigate(`/profile/${networkId}`, { state: profileStatus });  
    };
    return (
        <div>
            <NavHeader />
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}
            <br/><br/>
            <br/><br/>
             <br/>
            {/* <h1>Group</h1> */}

             {/* {(!myActiveGroups || myActiveGroups.length !== 0) && (
                <>
                <div className={`${styles.myGroupsSection} ${styles.pnGroup}`}>
                    {(!myGroups || myGroups.length !== 0) && (
                        <>
                        <h3>👥Active Groups👥 ({myActiveGroups.length})</h3>
                        <p className={styles.sectionSubtext}>Calling Features Soon!</p>
                        <ul>
                            <div className={styles.groupBox}>
                                <div className={styles.groupContainer}>
                                    {myActiveGroups?.map((group, index) => (
                                        <div  className={styles.groupItem}>
                                            <li key={group._id} onClick={(e) => handleGroupClick(e, group)}>
                                                <div className={styles.groupContent}></div>
                                                <img title={group.name} src={group.profilePicture ? group.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultGroup2}alt="pfp" className={styles.networkProfilePicture} />
                                                    <span className={styles.groupName}>🌟 {group.name} 🌟</span>
                                                    <span className={styles.groupMembers}>{group.participantCount} members</span>
                                                    <button 
                                                        className={styles.threeDotsButton} 
                                                        onClick={(e) => {handleGroupOptions(e, showOptions === index ? null : index)}} title="options"
                                                    >
                                                        ⋮
                                                    </button>
                                                    <div className={styles.groupActivity}>
                                                        <span className={styles.activityIndicator}>💚 Active now!</span>
                                                        <span className={styles.activityIndicator} onClick={(e) => handleGroupChatClick(e, group)}>💚 Chat📃</span>
                                                    </div>
                                            </li>
                                            {showOptions === index && (
                                                <div className={styles.messageOptionsMenu}>
                                                    <button 
                                                    onClick={(e) => 
                                                    {handleCopyInviteLink(e, group._id);setShowOptions(null)}}>
                                                        <CopyLinkIcon/>
                                                        Copy Invite Link
                                                    </button>
                                                    <button 
                                                    onClick={(e) => 
                                                    {handleLeaveGroup(e, group._id);setShowOptions(null)}}>
                                                        <LeaveGroupIcon/>
                                                        Leave Group
                                                    </button>
                                                    <button 
                                                    onClick={(e) => {handleReportGroupPopup(group._id);setShowOptions(null)}}>
                                                        <ReportIcon/>
                                                        Report Group
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </ul>
                        </>
                        )}

                    {(!leftGroups || leftGroups.length !== 0) && (
                    <>
                    <h3>Left Groups👥 ({leftGroups.length})</h3>
                    <p className={styles.sectionSubtext}>Calling Features Soon!</p>
                    <ul>
                        <div className={styles.groupBox}>
                            <div className={styles.groupContainer}>
                                {leftGroups?.map((group, index) => (
                                    <div  className={styles.groupItem}>
                                        <li key={group._id} onClick={(e) => handleGroupClick(e, group)}>
                                            <div className={styles.groupContent}></div>
                                            <img title={group.name} src={group.profilePicture ? group.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultGroup2}alt="pfp" className={styles.networkProfilePicture} />
                                                <span className={styles.groupName}>🌟 {group.name} 🌟</span>
                                                <span className={styles.groupMembers}>{group.participantCount} members</span>
                                                <button 
                                                    className={styles.threeDotsButton} 
                                                    onClick={(e) => {handleGroupOptions(e, showOptions === index ? null : index)}} title="options"
                                                >
                                                    ⋮
                                                </button>
                                                <div className={styles.groupActivity}>
                                                    <span className={styles.activityIndicator}>💚 Active now!</span>
                                                    <span className={styles.activityIndicator} onClick={(e) => handleGroupChatClick(e, group)}>💚 Chat📃</span>
                                                </div>
                                        </li>
                                        {showOptions === index && (
                                            <div className={styles.messageOptionsMenu}>
                                                <button 
                                                onClick={(e) => 
                                                {handleCopyInviteLink(e, group._id);setShowOptions(null)}}>
                                                    <CopyLinkIcon/>
                                                    Copy Invite Link
                                                </button>
                                                <button 
                                                onClick={(e) => 
                                                {handleLeaveGroup(e, group._id);setShowOptions(null)}}>
                                                    <LeaveGroupIcon/>
                                                    Leave Group
                                                </button>
                                                <button 
                                                onClick={(e) => {handleReportGroupPopup(group._id);setShowOptions(null)}}>
                                                    <ReportIcon/>
                                                    Report Group
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </ul>
                    </>
                )}
                </div>
                </>
            )}
             */}
            {(!myGroups || myGroups.length !== 0) && (
                <div className={`${styles.myGroupsSection} ${styles.pnGroup}`}>
                        <h3>👥Active Groups👥 ({myGroups.length})</h3>
                        <p className={styles.sectionSubtext}>Calling Features Soon!</p>
                        <ul>
                            <div className={styles.groupBox}>
                                <div className={styles.groupContainer}>
                                    {myGroups?.map((group, index) => (
                                        <div  className={styles.groupItem}>
                                            <li key={group._id} onClick={(e) => handleGroupClick(e, group)}>
                                                <div className={styles.groupContent}></div>
                                                <img title={group.name} src={group.profilePicture ? group.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultGroup2}alt="pfp" className={styles.networkProfilePicture} />
                                                    <span className={styles.groupName}>🌟 {group.name} 🌟</span>
                                                    <span className={styles.groupMembers}>{group.participantCount} members</span>
                                                    <button 
                                                        className={styles.threeDotsButton} 
                                                        onClick={(e) => {handleGroupOptions(e, showOptions === index ? null : index)}} title="options"
                                                    >
                                                        ⋮
                                                    </button>
                                                    <div className={styles.groupActivity}>
                                                        <span className={styles.activityIndicator}>💚 Active now!</span>
                                                        <span className={styles.activityIndicator} onClick={(e) => handleGroupChatClick(e, group)}>💚 Chat📃</span>
                                                    </div>
                                            </li>
                                            {showOptions === index && (
                                                <div className={styles.messageOptionsMenu}>
                                                    <button 
                                                    onClick={(e) => 
                                                    {handleCopyInviteLink(e, group._id);setShowOptions(null)}}>
                                                        <CopyLinkIcon/>
                                                        Copy Invite Link
                                                    </button>

                                                    {group.membership==='member' && <button 
                                                        onClick={(e) => 
                                                        {handleLeaveGroup(e, group._id);setShowOptions(null)}}>
                                                            <LeaveGroupIcon/>
                                                            Leave Group
                                                        </button>
                                                    }
                                                    {group.membership==='left' && <button 
                                                        onClick={(e) => 
                                                        {handleDeleteGroup(e, group._id);setShowOptions(null)}}>
                                                            <LeaveGroupIcon/>
                                                            Delete Group
                                                        </button>
                                                    }
                                                    <button 
                                                    onClick={(e) => {handleReportGroupPopup(group._id);setShowOptions(null)}}>
                                                        <ReportIcon/>
                                                        Report Group
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </ul>
                </div>
            )}

            <div className={`${styles.createGroupSection} ${styles.pnGroup}`}>
                    <h3>Create Your Group!</h3>
                    <p className={styles.sectionSubtext}>Bring Friends together</p>
                    {!showGroupCreation && <button onClick={handleShowGroupCreation} className={styles.primaryAction}>
                        Create New Group
                    </button>}
            </div>

            {showGroupCreation && (
                <div className={styles.mainContent}>
                    <div className={styles.leftColumn}>
                        <div className={styles.groupCreationForm}>
                            <h4>🌈 Give Your Group a Special Name 🌈</h4>
                            <input
                                type="text"
                                value={groupName}
                                onChange={(e) => setGroupName(e.target.value)}
                                placeholder="Set Group Name"
                                className={styles.groupNameInput}
                            />
                            <button onClick={handleCreateGroup} className={styles.createButton}>
                                🎊 Create Group! 🎊
                            </button>
                            <button onClick={handleShowGroupCreation} className={styles.closeCreateGroupButton}>
                                Cancel
                            </button>
                        </div>
                    </div>
                    <div className={styles.rightColumn}>
                        {(projectNetworkList || projectNetworkList.length !== 0) &&  (
                            <div className={`${styles.networksSection} ${styles.pnGroup}`}>
                                <h3>Add Friends</h3>
                                <ul>
                                    {projectNetworkList?.map(network => (
                                        <li key={network._id} className={styles.networkItem} 
                                        onClick={(e) => handleSelectNetwork(e, network._id)}
                                        >
                                            <div className={styles.networkInfo} >
                                                <img title={network.name} src={network.profilePicture ? network.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                                <span className={styles.networkName}>💫 {network.name} 💫</span>
                                                <span className={styles.connectionTime}>{network.skills}</span>
                                                <input type="checkbox" checked={selectedNetworks.includes(network._id)}/>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                                {(!projectNetworkList || projectNetworkList.length === 0) && (
                                <div className={styles.emptyState}>
                                    <p>🥺 No connections yet? Let's find some amazing people to connect with! 🥺</p>
                                </div> 
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
            {reportGroupPopup && (
                <div className={styles.popupOverlay}>
                    <div className={styles.popupContent}>
                        <h2>Reporting Group</h2>
                        <p>Thanks, Reported Group are reviewed shortly.</p>
                            <textArea
                                type="text"
                                value={reportMessage}
                                onChange={(e) => setReportMessage(e.target.value)}
                                placeholder="Report Message (Optional)"
                                className={styles.reportMessageInput}
                            />
                        <div className={styles.popupActions}>
                            <button onClick={(e)=>handleReportGroup(e, reportGroupId)} className={styles.confirmButton}>Report</button>
                            <button onClick={cancelReportGroup} className={styles.cancelButton}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}
            {activeGroupChat && (
                <SocialMessageBox socialType={socialType} social={activeGroupChat} onClose={handleCloseChat} />
            )}
            
        </div>
    );
}
export default Groups;